/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Oneglue_Key_Minted_DescInputs */



/**
* | output |
* | --- |
* | "A oneGlue inference key was issued for a member." |
*
* @param {Audit_Details_Oneglue_Key_Minted_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_oneglue_key_minted_desc = /** @type {((inputs?: Audit_Details_Oneglue_Key_Minted_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Oneglue_Key_Minted_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Für ein Mitglied wurde ein oneGlue-Inferenz-Schlüssel ausgestellt.")
	return /** @type {LocalizedString} */ ("A oneGlue inference key was issued for a member.")
});